import { Refresh } from '@mui/icons-material';

/**
 * A custom badge that alerts on version mismatch
 * lets the user refresh the page with a button.
 *
 * This badge doesn't use ToastContentProps because it doesn't require any props to be passed from the parent
 */
export const VersionMismatchBadge = () => {
  return (
    <div className="flex flex-row justify-between items-center w-full bg-white rounded-md relative">
      <div className="flex flex-col">
        <h3 className="label-02 font-semibold">New version available</h3>
        <p className="body-03">Refresh to update to the latest version</p>
      </div>

      <div className="flex items-center justify-center">
        <div
          className="flex flex-col cursor-pointer items-center justify-center gap-1 hover:bg-gray-100 active:bg-gray-200 p-2 rounded-md"
          onClick={() => {
            // Only reload might not be the best solutions
            // We might want to do a more thorough clean up if this is proven insufficient
            window.location.reload();
          }}
        >
          <Refresh fontSize="large" className={'text-interactive'} />
        </div>
      </div>
    </div>
  );
};
